import fr from '../../translation/fr_FR'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'fr',
        iso: 'fr-FR',
      },
    ],
    defaultLocale: 'fr',
    vueI18n: {
      fallbackLocale: 'fr',
      messages: {
        fr,
      },
    },
    pages: {
      'categories/business': {
        fr: '/business',
      },
      'categories/get-inspired': {
        fr: '/trouvez-linspiration',
      },
      'categories/how-to': {
        fr: '/tutoriels',
      },
      'categories/news': {
        fr: '/les-nouveautes',
      },
      'categories/printstories': {
        fr: '/printstories',
      },
      'editorial-staff/index': {
        fr: '/redaction',
      },
      'editorial-staff/_author': {
        fr: '/redaction/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/',
      },
      {
        key: 'business',
        wpUri: '/business/',
      },
      {
        key: 'get-inspired',
        wpUri: '/trouvez-linspiration/',
      },
      {
        key: 'how-to',
        wpUri: '/tutoriels/',
      },
      {
        key: 'news',
        wpUri: '/les-nouveautes/',
      },
      {
        key: 'printstories',
        wpUri: '/printstories/',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redaction/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'business',
        wpSlug: 'business',
        view: 'categories-business',
        wpCategoryId: 3756,
      },
      {
        key: 'get-inspired',
        wpSlug: 'trouvezlinspiration',
        view: 'categories-get-inspired',
        wpCategoryId: 69,
      },
      {
        key: 'how-to',
        wpSlug: 'tutoriels',
        view: 'categories-how-to',
        wpCategoryId: 67,
      },
      {
        key: 'news',
        wpSlug: 'lesnouveautes',
        view: 'categories-news',
        wpCategoryId: 70,
      },
      {
        key: 'printstories',
        wpSlug: 'printstories',
        view: 'categories-printstories',
        wpCategoryId: 11383,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 11264,
      },
      {
        key: 'business-growth',
        wpSlug: 'businessgrowth',
        view: null,
        wpCategoryId: 11265,
      },
    ],
  },
  pixartWebsite: 'https://www.pixartprinting.fr/',
  navigation: {
    primary: {
      order: ['business', 'printstories', 'how-to', 'get-inspired', 'news'],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights', 'business-growth'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/pixartprinting.fr/',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/pixartprinting/',
    },
    {
      key: 'linkedin',
      url: 'https://www.linkedin.com/company/pixartprinting/',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://www.pixartprinting.fr/protection-des-donnees-personnels/',
    },
  ],
  shopLinks: [
    {
      label: 'Impression en ligne',
      url: 'https://www.pixartprinting.fr/',
    },
    {
      label: 'Cartes de visite',
      url: 'https://www.pixartprinting.fr/cartes-de-visite/',
    },
    {
      label: 'Flyers et tracts',
      url: 'https://www.pixartprinting.fr/petit-format/impression-flyers-tractes/',
    },
    {
      label: 'Étiquettes autocollantes',
      url: 'https://www.pixartprinting.fr/impression-etiquettes/',
    },
    {
      label: 'Autocollants',
      url: 'https://www.pixartprinting.fr/impression-etiquettes/etiquettes-adhesives/',
    },
    {
      label: 'Packaging',
      url: 'https://www.pixartprinting.fr/packaging/',
    },
    {
      label: 'Boîtes personnalisées',
      url: 'https://www.pixartprinting.fr/packaging/boite-personnalisee/',
    },
    {
      label: 'Sacs personnalisés',
      url: 'https://www.pixartprinting.fr/sac-personnalise/',
    },
    {
      label: 'Revues, livres, catalogues',
      url: 'https://www.pixartprinting.fr/impression-revues-catalogues-livres/',
    },
    {
      label: 'Impression sur toile',
      url: 'https://www.pixartprinting.fr/impression-photo/impression-sur-toile/',
    },
    {
      label: 'Goodies personnalisés',
      url: 'https://www.pixartprinting.fr/gadgets-personnalises/',
    },
    {
      label: 'Calendriers et agendas',
      url: 'https://www.pixartprinting.fr/calendriers/',
    },
  ],
}
